import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaArrowUp } from 'react-icons/fa';
import confetti from 'canvas-confetti';

const LevelUpNotification = ({ level, onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);
  const hasPlayedConfetti = useRef(false);

  useEffect(() => {
    // 只播放一次煙火
    if (!hasPlayedConfetti.current) {
      hasPlayedConfetti.current = true;
      
      confetti({
        particleCount: 20,
        spread: 40,
        origin: { y: 0.2 },
        colors: ['#FFD700', '#FFA500'],
        startVelocity: 20,
        decay: 0.9
      });
    }

    // 極短顯示時間 - 只顯示0.6秒
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 600);

    // 完全移除 - 0.8秒後調用 onComplete
    const completeTimer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, 800);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  const getLevelInfo = () => {
    switch(level) {
      case 2: return { title: '衝刺', color: 'from-green-400 to-green-600' };
      case 3: return { title: '疾風', color: 'from-blue-400 to-blue-600' };
      case 4: return { title: '閃電', color: 'from-purple-400 to-purple-600' };
      case 5: return { title: '光速', color: 'from-red-400 to-red-600' };
      default: return { title: '升級!', color: 'from-yellow-400 to-orange-600' };
    }
  };

  const info = getLevelInfo();

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 pointer-events-none z-[100] w-full flex justify-center">
      <AnimatePresence mode="wait">
        {isVisible && (
          <motion.div
            key={`level-${level}`}
            initial={{ y: -30, opacity: 0, scale: 0.7 }}
            animate={{ y: 0, opacity: 1, scale: 1 }}
            exit={{ y: -15, opacity: 0, scale: 0.5 }}
            transition={{ 
              type: 'spring', 
              damping: 15, 
              stiffness: 400,
              exit: { duration: 0.15 }
            }}
            className={`
              bg-gradient-to-r ${info.color} 
              text-white px-5 py-1.5 rounded-full shadow-xl 
              flex items-center gap-2 border-2 border-white/50
            `}
          >
            <div className="bg-white/20 p-1 rounded-full">
              <FaArrowUp className="text-white text-xs" />
            </div>
            
            <div className="flex items-baseline gap-1.5">
              <span className="text-xs font-bold opacity-90 uppercase tracking-wider">LV</span>
              <span className="text-lg font-black">{level}</span>
              <span className="text-xs font-bold pl-1.5 border-l border-white/30">
                {info.title}
              </span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LevelUpNotification;